import { Component, Inject, Input, OnInit, OnDestroy, PLATFORM_ID } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TransferState } from '@angular/platform-browser';
import moment from "moment";
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FlightFinderInitState, FlightFinderRequest } from '../../../shared/models/flight-finder.interface';
import { isPlatformBrowser } from "@angular/common";
import { ModalData } from '../../../shared/models/modal.interface';
import { FlightAPIRequest } from '../../../booking/models/flight-request.interface';
// service
import { FlightDetailsService } from '../../../shared/services/flight-details.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { AbandonmentService } from "../../../shared/services/abandonment.service";
import { AppStateService } from "../../../shared/services/app-state.service";
import { AppLoaderService } from "../../../shared/services/app-loader.service";
import { environment } from "../../../../environments/environment";


declare var exponea: any;
declare var ga: any;

@Component({
  selector: "app-get-flyback-flight-results",
  templateUrl: "./get-flyback-flight-results.component.html",
  styleUrls: ["./get-flyback-flight-results.component.scss"],
})
export class GetFlybackFlightResultsComponent implements OnInit, OnDestroy {
  @Input() bookingReference;
  @Input() flightDirection;
  @Input() flightData;
  @Input() airline;

  @Input() copyLoaded;
  @Input() appCopy;
  @Input() appAirportCopy;
  @Input() selectedLanguage;
  @Input() languageCode;

  @Input() showFlyBackSection;

  private _quoteFlightDataSubscription: Subscription;
  private _quoteRequestSubscription: Subscription;
  private _flightStoreData: Subscription;
  private _flightProductSelect: Subscription;

  private _apiNoResultCount = 1;
  private _multiLegsLoaded = { direct: true, oneStop: false, twoStop: false };
  private _filterTimeout;
  public flightResults = [];
  public firstLoad = true;
  public cacheUsed = false;
  public isMultiLegFlight = false;
  public flightConnectionCount = 0;

  public pagingArr = [];
  public pageSetSize = 4;
  public selectedPage = 1;
  public activeSetIndex = 1;
  public activeRadioIndex = 0;

  public modalSelectingProductType = false;
  public searchByFlightNumberCheck = false;
  public modalData;

  public serviceSelectionApiRequest: any;
  public serviceSelectionFlightData: any;

  public autoSetCCDforFlyback = true; // modify this if ABC is enabled for flyback

  public flightResultsLoading = true;
  public flightSelectionInprogress = false;
  public selectedFlightId = null;
  public isMultiLegLoaded = false;

  public flightLeg = {
    direct: true,
    oneStop: false,
    twoStop: false
  };
  public direction = null;
  public flightNumber = { value: null };

  private _flightResultCount = 0;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _appStore: Store<AppState>,
    private _flightDetailsService: FlightDetailsService,
    private _errorService: ErrorHandler,
    private _appStateService: AppStateService,
    private _activatedRoute: ActivatedRoute,
    private _dataStorageService: DataStorageService,
    private _abandonmentService: AbandonmentService,
    private _serverState: TransferState,
    private _appLoaderService: AppLoaderService,
    private _router: Router) { }

  ngOnInit(): void {
    // this.departureAirport =
    //   this.flightData.flightStatusDetails[
    //     this.flightData.flightStatusDetails.length - 1
    //   ].arrivalAirport;

    // this.arrivalAirport = this.flightData.flightStatusDetails[0].departureAirport;
    // this.flightReturnDate = this.getState(this._appStore).flybackReducer.flybackFlightDate;

    // this.checkInitialFlightData();
    this.setDataSubscriptions();
    this.setFlightRequestParams();

    // TODO: check this
    this._appStateService.resetBookingStateData();

    const promoCode = this.getState(this._appStore).oldBookingInfoReducer.d2dReducer.promoCode[0];

    if (promoCode) {
      // manual promo - re-hidrate promo code if there is any in the previouse booking or selected before
      this._appStore.dispatch({ type: 'UPDATE_PROMO', payload: promoCode });
    }

  }

  // checkInitialFlightData() {
  //   const resultLength = this.getState(this._appStore).flightFinderReducer.quoteFlightResults.length;
  //   const departureAirport = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.departureAirport;
  //   const arrivalAirport = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.arrivalAirport;
  //   const airlineCode = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.airline;
  //   const airlineName = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.airlineName;
  //   const flightDate = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.departDate;
  //   const paginationFlightResponse = this.getState(this._appStore).flightFinderReducer.paginationFlightResponse;

  //   const storeMissingData = resultLength === 0 && (departureAirport === null || arrivalAirport === null);
  //   const storeMissingAnyData = resultLength === 0 || (departureAirport === null || arrivalAirport === null);

  //   try {
  //     this.selectedPage = paginationFlightResponse.pageNumber;
  //     this.activeRadioIndex = this.selectedPage - 1;
  //   } catch (err) {
  //     console.log('missing cache page number');
  //   }

  //   if (paginationFlightResponse !== null && resultLength === 0 && !this.cacheUsed && this.firstLoad) {
  //     this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST', payload: this.getState(this._appStore).flightFinderReducer.paginationFlightResponse });
  //     this._appStore.dispatch({ type: 'INCREMENT_REQUEST_COUNT' });
  //     this._appStore.dispatch({ type: 'UPDATE_PAGINATION_DATA', payload: null });
  //     this.firstLoad = false;
  //     this.cacheUsed = true;
  //   } else if (storeMissingData && this.firstLoad) {
  //     // rediect back to search if data not found
  //     // show messge if come from search
  //     // this._appStore.dispatch({ type: 'UPDATE_REDIRECT_TO_SEARCH', payload: true });
  //     // this.firstLoad = false;
  //     // this._router.navigate(['flight-finder/search'], {queryParams: {'start-booking': true}});
  //   } else if ((storeMissingAnyData && this.firstLoad)) {
  //     exponea.track('no_flight_results', {
  //       airline_name: airlineName,
  //       airline_code: airlineCode,
  //       departure_airport: departureAirport,
  //       arrival_airport: arrivalAirport,
  //       flight_date: flightDate
  //     });
  //     this._errorService.handleCustomError({
  //       text: 'You seem to have no flight results. Please search again.',
  //       sticky: false
  //     });
  //     // this._appStore.dispatch({ type: 'UPDATE_REDIRECT_TO_SEARCH', payload: true });
  //     this.firstLoad = false;
  //     // this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
  //   }

  //   this._flightProductSelect = this._flightDetailsService.getFlightStatus$
  //     .subscribe(data => {
  //       // code
  //       this.modalData = data;
  //       this.searchByFlightNumberCheck = true
  //       this.modalSelectingProductType = true;
  //       this.flightResultsLoading = true;
  //     });

  // }

  // after service selection (service model)
  getSelectedProductType(e) {
    this.modalSelectingProductType = false;
    console.log(e.data)
    if (e.isTypeSelected) {
      this._appLoaderService.showLoader();
      this.flightResultsLoading = true;
      const { multiLegData, res, hasFlightSession, isLinkedConnection, productTypeAvailability } = e.data;
      const productAvailability = e.productAvailability;
      if (this.isMultiLegFlight) {
        if (this.modalData.res.flightDirection === 2) {
          this.serviceSelectionApiRequest.firstLeg.flightDirection = 2;
          this.serviceSelectionApiRequest.lastLeg.flightDirection = 2;
          this.serviceSelectionApiRequest.firstLeg.isPrimary = false;
          this.serviceSelectionApiRequest.lastLeg.isPrimary = true;
          this._flightDetailsService.getFlightStatsData(this.serviceSelectionFlightData, this.serviceSelectionApiRequest, false, false, undefined, true, productAvailability, null, null, true);
        } else {
          this._flightDetailsService.setFlightStoreItems(multiLegData, res, hasFlightSession, isLinkedConnection, productAvailability, true);
        }
      } else {
        this._flightDetailsService.setFlightStoreItems(multiLegData, res, hasFlightSession, isLinkedConnection, productAvailability, true);
      }
    } else {
      this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
    }
  }

  setDataSubscriptions() {


    this._quoteRequestSubscription = this._appStore.select('flightFinderReducer')
      .subscribe((res: FlightFinderInitState) => {
        // call flight api
        // check requestCount var - increment count value in store to call api
        if (res.requestCount === 0 || typeof res.requestCount === 'undefined' || res.requestCount === this._flightResultCount) { return; }
        this.setFlightRequestParams(res);
      });

    this._quoteFlightDataSubscription = this._flightDetailsService.flightResults$
      .subscribe(data => {

        this.flightResultsLoading = false;

        if (!data) { return; }

        try {

          if (typeof data.flightConnections.length !== 'undefined') {
            this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_RESULTS', payload: data.flightConnections });
            this._appStore.dispatch({ type: 'UPDATE_PAGINATION_DATA', payload: data.paginationFlightResponse });
            this._appStore.dispatch({ type: 'UPDATE_FLIGHT_CONNECTION_COUNT', payload: data.flightConnectionsCount });
          }

          if (data.flightConnections.length === 0 && (this._apiNoResultCount !== 3 && !this._multiLegsLoaded.twoStop)) {

            this._apiNoResultCount++;
            this._multiLegsLoaded = JSON.parse(JSON.stringify(this._multiLegsLoaded));
            if (this._apiNoResultCount === 2) {
              this._multiLegsLoaded.oneStop = true;
            } else if (this._apiNoResultCount === 3) {
              this._multiLegsLoaded.twoStop = true;
            }

            if (isPlatformBrowser(this.platformId)) {
              this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: true });
              this._appStore.dispatch({ type: 'UPDATE_FILTER_LEGS', payload: this._multiLegsLoaded });
              this.setFlightRequestParams();
            }
          } else {

            if (isPlatformBrowser(this.platformId)) {
              this._dataStorageService.saveData();
            }
          }
        } catch (err) {
          const departureAirport = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.departureAirport;
          const arrivalAirport = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.arrivalAirport;
          const airlineCode = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.airline;
          const airlineName = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.airlineName;
          const flightDate = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.departDate;

          exponea.track('no_flight_results', {
            airline_name: airlineName,
            airline_code: airlineCode,
            departure_airport: departureAirport,
            arrival_airport: arrivalAirport,
            flight_date: flightDate,
            entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
          });
          this._errorService.handleCustomError({
            text: 'You seem to have no flight results. Please search again.',
            sticky: false
          });

          const url = new URL(environment.homeURL);
          url.searchParams.set('noFlightsFound', 'true');
          window.location.replace(url.toString());

          this.flightResultsLoading = false;

        }
      }, err => {
        this.flightResultsLoading = false;
        console.log(err);
      });

    this._flightStoreData = this._appStore.select('flightFinderReducer')
      .subscribe((res: FlightFinderInitState) => {

        if (res.paginationFlightResponse !== null) {

          const resultPageAmount = Math.ceil(res.flightConnectionCount / res.paginationFlightResponse.pageSize);

          // if leg filter changed, reset pagination
          if (this.flightConnectionCount !== res.flightConnectionCount) {
            this.pagingArr = [];
            this.selectedPage = 1;
            this.activeRadioIndex = 0;
            this.flightConnectionCount = res.flightConnectionCount;

            for (let n = 1; n <= resultPageAmount; n++) {
              this.pagingArr.push({ type: 'page' + n, value: n });
            }
          }

        } else if ((res.paginationFlightResponse === null && res.quoteFlightCacheRequest === null) && res.quoteFlightResults.length === 0) {
          // console.log('err');
          // if (res.requestCount === 0 || res.requestCount === 3) {
          //   setTimeout(() => {
          //     this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          //     return;
          //   }, 250);
          // }
        }

        // if (res.requestCount === 0 && !this.firstLoad) { return; }
        // this.firstLoad = false;

        try {
          // const isPartner = this.checkAirlineIsPartner(res.quoteFlightRequest.airline);

          // if (isPartner) {
          //   // sometimes datalinks don't have full name, or it comes truncated, so use the airline code to get the full name
          //   const partnerConfig = ABC_PARTNERS.find(partner => partner.code === res.quoteFlightRequest.airline.toLocaleUpperCase());

          //   this.flightData.airlineName = partnerConfig.codeName;
          //   this.flightData.isPartner = true;
          // } else {
          //   this.flightData.airlineName = res.quoteFlightRequest.airlineName;
          //   this.flightData.isPartner = false;
          // }

          // // BREAK HERE!!
          // this.flightData.airlineCode = res.quoteFlightRequest.airline;
          // this.flightData.originAirportCode = res.quoteFlightRequest.departureAirport;
          // this.flightData.originAirportName = res.quoteFlightRequest.fromAirport; // null
          // this.flightData.originCity = res.quoteFlightRequest.fromCity;
          // this.flightData.destinationAirportCode = res.quoteFlightRequest.arrivalAirport;
          // this.flightData.destinationAirportName = res.quoteFlightRequest.toAirport; // null
          // this.flightData.destinationCity = res.quoteFlightRequest.toCity;
          // this.flightData.date = res.quoteFlightRequest.departDate;

          if (res.quoteFlightResults.length === 0) {
            this.flightResults = [];
          } else {
            this.flightResults = res.quoteFlightResults;
          }
          if (this.flightResultsLoading) {
            this._appStore.dispatch({ type: 'UPDATE_VIRTUAL_BAGS', payload: res.quoteFlightRequest.bagCount });
            this._appStore.dispatch({ type: 'UPDATE_BAG_ITEMS', payload: res.quoteFlightRequest.bagItems });
            this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
          }
        } catch (error) {
          console.log('break on missing data');
          // setTimeout(() => {
          //   this._router.navigate(['flight-finder/search'], { queryParams: { 'start-booking': true } });
          //   return;
          // }, 250);

        }

        // this._appLoaderService.hideLoader();
        // this.dataLoaded = true;
        this.flightResultsLoading = false;

      });

    this._flightProductSelect = this._flightDetailsService.getFlightStatus$
      .subscribe(data => {
        // code
        this.modalData = data;
        this.modalSelectingProductType = true;
        this.flightResultsLoading = true;
      });

  }

  // checkAirlineIsPartner(code: string) {
  //   const foundPartner = ABC_PARTNERS.find(partner => partner.code === code.toLocaleUpperCase());

  //   return foundPartner ? true : false;
  // }

  handlePageClick(dir) {

    if (dir === 'next') {
      this.activeSetIndex++;
    } else {
      this.activeSetIndex--;
    }
  }

  handlePageNumberClick(page: { value: number, type: string }) {
    let requestData = this.getState(this._appStore).flightFinderReducer.paginationFlightResponse;
    const data = JSON.parse(JSON.stringify(requestData));
    data.pageNumber = page.value;
    requestData = data;

    this.selectedPage = page.value;
    this.activeRadioIndex = this.selectedPage - 1;

    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST', payload: requestData });
    this._appStore.dispatch({ type: 'INCREMENT_REQUEST_COUNT' });
  }

  selectFlight({ flight, flightStatsResponse }) {
    this._appStore.dispatch({ type: 'UPDATE_PARTNER_NAME', payload: { partnerName: 'NONE' } });

    const productTypeAvailability = '';

    let quoteFlightDirection;
    let flightDirection;

    quoteFlightDirection = this.getState(this._appStore).flightFinderReducer.quoteFlightRequest.flightDirection;
    const flybackAvailability = this.getState(this._appStore).flybackReducer;
    if (flybackAvailability.ccdAvailable && !flybackAvailability.abcAvailable) {
      quoteFlightDirection = 2
    }
    flightDirection = quoteFlightDirection ? quoteFlightDirection : flight.flightDirection;
    if (flight.totalNumberOfLegs > 1 || flight.productAvailability === null) {
      this.isMultiLegFlight = true;
      this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: true });
    }

    this.flightSelectionInprogress = true
    this._appLoaderService.showLoader();
    this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: true });

    // if data is sent from flight number filter
    // call flight stats with pass in data
    if (flight.flightNumberSearch) {

      const flightNumberRequest = {
        firstLeg: {
          flightNumber: flight.flightNumber,
          flightDirection: quoteFlightDirection ? quoteFlightDirection : this._flightDetailsService.checkDirection(this.flightData.originAirportCode),
          departureDate: this.flightData.date,
          isPrimary: true
        }
      };

      this._appStore.dispatch({ type: 'UPDATE_FLIGHT_NUMBER_REQUEST', payload: flightNumberRequest });

      const bags = this.getState(this._appStore).flybackReducer.quoteFlightRequest.bagCount;
      this._appStore.dispatch({ type: 'UPDATE_VIRTUAL_BAGS', payload: bags });
      const bagItems = { ...this.getState(this._appStore).flybackReducer.quoteFlightRequest.bagItems };
      this._appStore.dispatch({ type: 'UPDATE_BAG_ITEMS', payload: bagItems });
      exponea.track('manual_flight_search', {
        flight_number: flight.flightNumber,
        departure_date: this.flightData.date,
        entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      });
      // updated for ccd/abc critical case
      this._flightDetailsService.getFlightStatsData(null, flightNumberRequest, false, false, undefined, true, null, null, null, true);
      return;
    }

    let request: FlightAPIRequest = {
      firstLeg: {
        flightNumber: flight.flightStatusDetails[0].airlineCode + flight.flightStatusDetails[0].flightNumber,
        flightDirection: flightDirection,
        departureDate: flightDirection == 1
          ? flight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal
          : flight.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: true
      }
    };

    if (this.isMultiLegFlight) {
      request.firstLeg.isPrimary = flight.flightStatusDetails[0].isPrimaryLeg;

      request.lastLeg = {
        flightNumber: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].airlineCode + flight.flightStatusDetails[flight.flightStatusDetails.length - 1].flightNumber,
        flightDirection: flightDirection,
        departureDate: flightDirection == 1
          ? flight.flightStatusDetails[flight.flightStatusDetails.length - 1].departureDateTimeDetails.scheduledDateTimeLocal
          : flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].isPrimaryLeg
      };
    }
    console.log(flight, request, 'flight and req');
    // updated for ccd/abc critical case
    const serviceProductAvailability = this.getState(this._appStore).flightReducer.flightDetails.flightProducts;
    if (this.isMultiLegFlight && flightDirection === 2) {
      request.firstLeg.isPrimary = false;
      request.lastLeg.isPrimary = true;
      request.firstLeg.flightDirection = 2;
      request.lastLeg.flightDirection = 2;
    }

    //
    this._flightDetailsService.getFlightStatsData(flight, request, false, false, undefined, undefined, undefined, undefined, flightStatsResponse, true);
    this.serviceSelectionApiRequest = request;
    this.serviceSelectionFlightData = flight;

    // Add For Checking
    // this._dataStorageService.saveData();
    // this._bookingService.getBookingReferenceForRequest();


    // if user is logged-in and has marketing flag
    const userEmail = this.getState(this._appStore).userReducer.userDetails.userEmail;
    const hasMarketingEnrolment = this.getState(this._appStore).userReducer.userDetails.hasMarketingEnrolment;

    if (userEmail !== '' && hasMarketingEnrolment) {

      const abandonmentRequest = {
        email: userEmail,
        from: flight.flightStatusDetails[0].departureAirport.airportName,
        fromCode: flight.flightStatusDetails[0].departureAirport.airportCode,
        to: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalAirport.airportName,
        toCode: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalAirport.airportCode,
        date: moment(flight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal).format('YYYY-MM-DD'),
        airline: flight.flightStatusDetails[0].airlineName,
        airlineCode: flight.flightStatusDetails[0].airlineCode,
        flightCode: flight.flightStatusDetails[0].flightNumber,
        direction: flight.flightDirection === 1 ? 'out' : 'in'
      };

      this._abandonmentService.setAbandonment(abandonmentRequest, 'Subscribe');
    }

  }

  // get store state
  setFlightRequestParams(res?) {

    this.flightResultsLoading = true;

    //  it should already be reseted
    if (!res) { res = this.getState(this._appStore).flightFinderReducer; }

    // what about filterLegs multilegs?

    let request: FlightFinderRequest = null;
    this._flightResultCount = res.requestCount;

    try {
      // set cache request here...
      if (res.quoteFlightCacheRequest !== null && res.quoteFlightCacheRequest.cacheId) {
        request = {
          paginationFlightRequest: {
            cacheId: res.quoteFlightCacheRequest.cacheId,
            pageSize: res.quoteFlightCacheRequest.pageSize,
            pageNumber: res.quoteFlightCacheRequest.pageNumber
          }
        };
      } else {
        request = this.handleFlightRequest(res, request);
      }
    } catch (error) {
      request = this.handleFlightRequest(res, request);
    }

    this._flightDetailsService.getFlightData(request);
  }

  private handleFlightRequest(res: any, request: FlightFinderRequest) {
    const flightDirection = this.flightDirection; // flyback flight direction
    const legValue: number = this.getLegValue(res.filterLegs);
    request = {
      departureAirportCode: res.quoteFlightRequest.departureAirport,
      arrivalAirportCode: res.quoteFlightRequest.arrivalAirport,
      flightDateTime: res.quoteFlightRequest.departDate,
      flightDirection: flightDirection,
      numberOfLegs: legValue,
      airlineCode: res.quoteFlightRequest.airline
    };
    return request;
  }

  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  getLegValue(obj) {
    let value = 1;

    if (obj.oneStop) { value = 2; }
    if (obj.twoStop) { value = 3; }

    return value;
  }

  searchNonDirect(filterObj) {

    this._appStore.dispatch({ type: 'UPDATE_FLIGHT_QUOTE_CACHE_REQUEST', payload: null });
    this._appStore.dispatch({ type: 'UPDATE_FILTER_LEGS', payload: filterObj });
    this._appStore.dispatch({ type: 'INCREMENT_REQUEST_COUNT' });
    this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: true });
    this.flightResultsLoading = true;
  }

  // filter results list based on passed in value
  flightNumberFilter(value: string) {

    if (this._filterTimeout) { clearTimeout(this._filterTimeout); }

    this._filterTimeout = setTimeout(() => {

      // if user searches for EZY change to u2 to match data
      if (value.toLocaleUpperCase().includes('EZY')) {
        const numVal = value.slice(3);
        const newValue = 'U2' + numVal;
        value = newValue;
      }

      // get the list from the store
      const allFlightResults = this.getState(this._appStore).flightFinderReducer.quoteFlightResults;

      if (value.length === 0) {
        this.flightResults = allFlightResults;
        return;
      }

      let viewData = [];

      viewData = allFlightResults.filter((i => { return i.flightInfo.requestFlightNumber.includes(value.toLocaleUpperCase()); }));
      this.flightResults = viewData;

    }, 350);
  }

  cancelFlightRequest(item) {
    this._flightDetailsService.cancelFlightRequest();
    this._appStore.dispatch({ type: 'UPDATE_USER_SELECTED', payload: false });
    this.flightResults = this.getState(this._appStore).flightFinderReducer.quoteFlightResults;

    for (const key in this._multiLegsLoaded) {
      if (item === key) {
        this._multiLegsLoaded[key] = false;
      }
    }

  }

  ngOnDestroy() {
    if (this._quoteRequestSubscription) { this._quoteRequestSubscription.unsubscribe(); }
    if (this._quoteFlightDataSubscription) { this._quoteFlightDataSubscription.unsubscribe(); }
    if (this._flightStoreData) { this._flightStoreData.unsubscribe(); }
    this.flightResults = [];
    this._appLoaderService.hideLoader();
  }
}
